<app-modal
  [isActive]="isActive"
  [isLarge]="true"
  (modalState)="closeModal.emit(true)"
  [showCloseFooter]="true"
>
  <p class="modal-card-title" modal-title>
    {{ 'itinerary-info.passengers-info.special-requests' | translate }}
    - <span class="is-capitalized">{{ name | lowercase }}</span>
  </p>

  <div modal-content>
    <mat-tab-group mat-align-tabs="center" *ngIf="isActive">
      <mat-tab [label]="'itinerary-info.passengers-info.special-requests' | translate">
        <div class="tab-box">
          <div class="container pt-4" *ngIf="onlySpecialRequests?.length === 0">
            <div class="columns mb-1pt">
              <div class="column has-text-centered">
                <div class="icon is-large">
                  <em class="mdi mdi-alert-circle mdi-48px has-text-grey"></em>
                </div>
              </div>
            </div>
            <app-title
              class="is-block has-text-centered"
              [medium]="true"
              title="{{ 'itinerary-info.passengers-info.not-special-requests' | translate }}"
            >
            </app-title>
          </div>

          <div *ngFor="let specialRequest of onlySpecialRequests">
            <app-flight-special-requests
              [specialRequest]="specialRequest"
              type="specialRequest"
            ></app-flight-special-requests>
          </div>
        </div>
      </mat-tab>

      <mat-tab [label]="'itinerary-info.passengers-info.ancillaries' | translate">
        <div class="tab-box">
          <div class="container pt-4" *ngIf="onlyAncillaries?.length === 0">
            <div class="columns mb-1pt">
              <div class="column has-text-centered">
                <div class="icon is-large">
                  <em class="mdi mdi-alert-circle mdi-48px has-text-grey"></em>
                </div>
              </div>
            </div>
            <app-title
              class="is-block has-text-centered"
              [medium]="true"
              title="{{ 'itinerary-info.passengers-info.not-ancillaries' | translate }}"
            >
            </app-title>
          </div>

          <div *ngFor="let ancillarie of onlyAncillaries">
            <app-flight-special-requests
              [specialRequest]="ancillarie"
              type="ancillarie"
            ></app-flight-special-requests>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</app-modal>
